/** Colunas padrão do Kanban de Leads (status = id da coluna na tabela leads). */
export const COLUNAS_PADRAO = [
  {
    id: 'novo_lead',
    titulo: 'Novo Lead',
    descricao: 'Entrou no sistema (formulário, WhatsApp, indicação)',
    emoji: '✳️',
    cor: '#3498db',
    corFundo: '#ebf3fd',
    isCustom: false
  },
  {
    id: 'contato_feito',
    titulo: 'Contato Feito',
    descricao: 'Já houve primeiro contato (mensagem, ligação ou e-mail)',
    emoji: '🔍',
    cor: '#f39c12',
    corFundo: '#fef5e7',
    isCustom: false
  },
  {
    id: 'proposta_enviada',
    titulo: 'Proposta Enviada',
    descricao: 'Enviou orçamento ou apresentação',
    emoji: '⏳',
    cor: '#9b59b6',
    corFundo: '#f4ecf7',
    isCustom: false
  },
  {
    id: 'negociacao',
    titulo: 'Negociação',
    descricao: 'Cliente demonstrou interesse, está avaliando ou pedindo ajustes',
    emoji: '💬',
    cor: '#e67e22',
    corFundo: '#fdf2e9',
    isCustom: false
  },
  {
    id: 'parado',
    titulo: 'Parado',
    descricao: 'Lead interessado mas pausado por questões externas (financiamento, reforma futura, etc.)',
    emoji: '⏸️',
    cor: '#95a5a6',
    corFundo: '#f8f9fa',
    isCustom: false
  },
  {
    id: 'fechado_ganhou',
    titulo: 'Fechado (Ganhou)',
    descricao: 'Cliente confirmou a compra / contrato fechado',
    emoji: '✅',
    cor: '#27ae60',
    corFundo: '#eafaf1',
    isCustom: false
  },
  {
    id: 'fechado_perdeu',
    titulo: 'Fechado (Perdido)',
    descricao: 'Lead desistiu, não respondeu ou escolheu outro fornecedor',
    emoji: '❌',
    cor: '#e74c3c',
    corFundo: '#fadbd8',
    isCustom: false
  }
]

const CORES_CUSTOM = [
  { cor: '#3498db', corFundo: '#ebf3fd' },
  { cor: '#16a085', corFundo: '#e8f8f5' },
  { cor: '#8e44ad', corFundo: '#f5eef8' },
  { cor: '#d35400', corFundo: '#fdf2e9' },
  { cor: '#2980b9', corFundo: '#ebf5fb' }
]

/** Converte título exibido em status para a tabela leads (ex: "Tentativa 1" → tentativa_1). */
export function tituloParaStatusId(titulo) {
  const base = String(titulo || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
  return base || 'coluna_custom'
}

export function getStorageKey(empresaId) {
  const id = empresaId?.id || empresaId || 'global'
  return `leads_kanban_config_v1_${id}`
}

export function loadKanbanConfig(empresaId) {
  try {
    const raw = localStorage.getItem(getStorageKey(empresaId))
    if (!raw) return { customColunas: [], ocultas: [] }
    const parsed = JSON.parse(raw)
    return {
      customColunas: Array.isArray(parsed.customColunas) ? parsed.customColunas : [],
      ocultas: Array.isArray(parsed.ocultas) ? parsed.ocultas : []
    }
  } catch {
    return { customColunas: [], ocultas: [] }
  }
}

export function saveKanbanConfig(empresaId, config) {
  localStorage.setItem(
    getStorageKey(empresaId),
    JSON.stringify({
      customColunas: config.customColunas || [],
      ocultas: config.ocultas || []
    })
  )
}

/** Mescla colunas padrão + customizadas (custom não sobrescreve id existente). */
export function mergeColunas(customColunas = []) {
  const map = new Map()
  COLUNAS_PADRAO.forEach((c) => map.set(c.id, { ...c }))
  customColunas.forEach((c) => {
    if (c?.id && !map.has(c.id)) map.set(c.id, { ...c, isCustom: true })
  })
  return [...map.values()]
}

export function getColunasVisiveis(todasColunas, ocultas = []) {
  const set = new Set(ocultas)
  return todasColunas.filter((c) => !set.has(c.id))
}

export function findColunaPorId(colunas, statusId) {
  const found = colunas.find((c) => c.id === statusId)
  if (found) return found
  return {
    id: statusId,
    titulo: statusId?.replace(/_/g, ' ') || 'Status',
    descricao: '',
    emoji: '📋',
    cor: '#7f8c8d',
    corFundo: '#ecf0f1',
    isCustom: true
  }
}

export function criarColunaCustom(titulo, descricao = '', emoji = '📌', colunasExistentes = []) {
  let id = tituloParaStatusId(titulo)
  const ids = new Set(colunasExistentes.map((c) => c.id))
  if (ids.has(id)) {
    let n = 2
    while (ids.has(`${id}_${n}`)) n++
    id = `${id}_${n}`
  }
  const paleta = CORES_CUSTOM[colunasExistentes.length % CORES_CUSTOM.length]
  return {
    id,
    titulo: String(titulo).trim(),
    descricao: descricao?.trim() || `Coluna personalizada — status: ${id}`,
    emoji,
    cor: paleta.cor,
    corFundo: paleta.corFundo,
    isCustom: true
  }
}
